export const queryStringToObject = (queryString: string) => {
    const searchParams = new URLSearchParams(queryString);
    const result: any = {};

    for (const key of Array.from(searchParams.keys())) {
        if (result[key] !== undefined) {
            continue;
        }
        const values = searchParams.getAll(key);
        if (values.length > 1) {
            result[key] = values;
        } else if (values.length === 1) {
            result[key] = values[0];
        }
    }

    return result;
}

export const removeUndefinedFields = (obj: any) => {
    for (let key in obj) {
        if ((obj[key] === false || obj[key] === undefined || obj[key] === null || obj[key] === 'null' || obj[key] === '' || obj[key]?.length === 0) && key !== 'id' && key !== 'page') {
            delete obj[key];
        }
        if (Array.isArray(obj[key])) {
            if (obj[key]?.length === 2 && obj[key][0] === 0 && obj[key][1] === 0) {
                delete obj[key];
            }
        }
    }
    return obj;
};

export const removeUnusedFields = (obj: any) => {
    for (let key in obj) {
        if (key === 'page' || key === 'id') {
            delete obj[key];
        }
    }
    return obj;
};

export const createQuery = (filter: any) => {
    const params = new URLSearchParams();
    for (const [key, value] of Object.entries(filter)) {
        if (value === undefined || value === null) {
            continue;
        }
        if (Array.isArray(value)) {
            for (const item of value) {
                params.append(key, String(item));
            }
        } else {
            params.append(key, String(value));
        }
    }
    return params.toString();
}

export const setPageParam = (search: string, page: number) => {
    const params = new URLSearchParams(search);
    params.delete('page')
    params.set('page', page.toString())
    return params.toString()
}
